export interface ChipData {
    key: number;
    label: string;
}
let uniqueKeyCounter = 0;

const isOperator = (token: string) => ["+", "-", "/", "*", "[", "]", "(", ")", "||"].includes(token);

export const generateUniqueKey = () => uniqueKeyCounter++;

export const createChipDataWithKeys = (labels: string[]): ChipData[] => {
    return labels?.map((label) => ({
        key: generateUniqueKey(),
        label,
    }));
};

export const stringFormulaToArray = (formula: string) => {
    const regex = /\s*(\|\||[+\-*/()[\]])\s*|([A-Za-z_]+(?:\s[A-Za-z_]+)*)\s*/g;
    const tokens: string[] = [];

    let match;
    while ((match = regex.exec(formula)) !== null) {
        if (match[1]) {
            tokens.push(match[1].trim());
        }

        if (match[2]) {
            tokens.push(match[2].trim());
        }
    }

    return tokens;
};

export const validateFormula = (chipData2: readonly ChipData[], isField: any): boolean => {
    if (chipData2.length === 0) return false;

    let parens = 0;
    let brackets = 0;

    let lastTokenWasOperator = true;

    for (let i = 0; i < chipData2.length; i++) {
        const token = chipData2[i].label.trim();

        if (isOperator(token)) {
            if (lastTokenWasOperator && token !== "(" && token !== "[") {
                return false;
            }

            if (token === "(") parens++;
            if (token === ")") parens--;
            if (token === "[") brackets++;
            if (token === "]") brackets--;

            if (parens < 0 || brackets < 0) return false;

            lastTokenWasOperator = token !== ")" && token !== "]";
        } else if (isField(token)) {
            if (!lastTokenWasOperator) {
                return false;
            }

            lastTokenWasOperator = false;
        } else {
            return false;
        }
    }

    if (lastTokenWasOperator || parens !== 0 || brackets !== 0) return false;

    return true;
};
